// app/javascript/projects/components/ProjectsDisplay.jsx
import React, {useCallback} from 'react';
import BillingModalMainRenew from './BillingModalMainRenew';
import { Button } from 'ui';
import { useHistory } from 'react-router-dom';
import { formatSubscriptionEndDate, formatSubscriptionPrice } from '../../../utils/subscriptionUtils';

function BillingModalMainBillingTrialing ({ subscription = {} }) {
  const history = useHistory();
  const upgradeSubscription = useCallback(() => {
    history.push('/users/upgrade');
  }, [history]);

  const upgrade = <div>
    <p>
      Upgrade to a paid plan for full access to Delve's AI features.
    </p>
    
    <div style={{ margin: '20px 20px 29px 0px' }}>
      <Button variant="white" onClick={upgradeSubscription}>
        Upgrade to Paid Subscription
      </Button>
    </div>
  </div>

  return (<BillingModalMainRenew
      subscription={subscription}
      postDiv={upgrade}
    >
      <p>
        Your free trial ends on {formatSubscriptionEndDate(subscription.current_period_end)}. After that, you'll be charged {formatSubscriptionPrice(subscription)} per {subscription.plan?.interval || 'month'}.
      </p>
  </BillingModalMainRenew>)
}

export default BillingModalMainBillingTrialing;
